<template>
  <div class="block">
    <div class="block__item block__intro">
      <div class="block__intro-item">
        <h1 v-if="!created">Новый чемпионат</h1>
        <h1 v-else>Черновик чемпионата</h1>
      </div>
    </div>
    <div class="block__item">
      <user-card
        :name="club.name"
        :link="clubLink"
        target="_blank"
      >
        <template slot="img">
          <div class="club-avatar">
            <img
              :src="club.logo"
              alt=""
            >
          </div>
        </template>
        <template slot="details">
          <div class="text-sm">Организатор чемпионата</div>
        </template>
        <template slot="actions">
          <a
            class="action color-primary"
            :href="manageClubLink"
            target="_blank"
          >
            <span class="action__container">
              <span class="action__icon">
                <icon icon-name="settings"></icon>
              </span>
              <span class="action__text">
                Управление клубом
              </span>
            </span>
          </a>
        </template>
      </user-card>
    </div>
    <div class="block__item">
      <div class="loader m-0" v-show="!ready"></div>
      <form
        v-show="ready"
        class="form"
        :class="{'form_show-err': showErrors}"
        @submit.prevent="submit"
        novalidate
      >
        <div
          class="form__item"
          :class="{'has-error': $v.fields.name.$error }"
        >
          <div class="field field_row">
            <div class="field__label">
              <label class="label">Название</label>
            </div>
            <div class="field__input">
              <div class="input">
                <input
                  v-model.trim="fields.name"
                  class="input__el"
                  type="text"
                  name="champ_name"
                  placeholder="Название чемпионата"
                  autocomplete="off"
                >
                <div class="input__border"></div>
                <div class="input__icons">
                  <div class="input__icon input__icon-err">
                    <icon icon-name='exclamation-circle-s'></icon>
                  </div>
                </div>
              </div>
              <div class="field__msg">
                <div
                  class="field-msg"
                  v-if="!$v.fields.name.required"
                  v-html="messages.name.required"
                >
                </div>
              </div>
            </div>
          </div>
        </div>
        <div
          class="form__item"
          :class="{'has-error': $v.fields.date.$error || backendErrors.dateOverlaps }"
        >
          <div class="field field_row">
            <div class="field__label">
              <label class="label">Период проведения</label>
            </div>
            <div class="field__input">
              <div style="max-width: 268px;">
                <!-- Desktop date-range-picker -->
                <div class="d-none d-md-block">
                  <date-range-picker v-model="fields.date" :hideClear="true" :hidePresets="true"></date-range-picker>
                </div>
                <!-- Mobile date-range-picker -->
                <div class="d-md-none">
                  <div class="input" ref="input">
                    <input
                      v-model="formattedDate"
                      class="input__el"
                      placeholder="Начало – Окончание"
                      readonly
                      @focus="() => { $refs.dateRangeModal.open() }"
                    >
                    <div class="input__border"></div>
                    <div class="input__icons">
                      <div class="input__icon input__icon-err">
                        <icon icon-name='exclamation-circle-s'></icon>
                      </div>
                      <div class="input__icon" v-show="!$v.fields.date.$error">
                        <icon icon-name="calendar"></icon>
                      </div>
                    </div>
                  </div>
                  <mobile-modal
                    ref="dateRangeModal"
                    name="Период проведения"
                    showResetBtn
                    :hideFooter="fields.date === $refs.mobileDatepicker && $refs.mobileDatepicker.innerValue"
                    @open="() => { $refs.mobileDatepicker.open() }"
                    @reset="() => { $refs.mobileDatepicker.clearDate() }"
                    @apply="() => { $refs.mobileDatepicker.confirmDate() }"
                  >
                    <date-range-picker
                      v-model="fields.date"
                      ref="mobileDatepicker"
                      :mobile="true"
                      :hidePresets="true"
                    >
                    </date-range-picker>
                  </mobile-modal>
                </div>
              </div>
              <div class="field__msg">
                <div
                  class="field-msg"
                  v-if="!$v.fields.date.isFilled"
                  v-html="messages.date.required"
                >
                </div>
                <div
                  class="field-msg"
                  v-if="backendErrors.dateOverlaps"
                  v-html="messages.date.overlaps"
                >
                </div>
              </div>
            </div>
          </div>
        </div>
        <div
          class="form__item"
          :class="{'has-error': $v.fields.discipline.$error }"
        >
          <div class="field field_row">
            <div class="field__label">
              <label class="label">Тип тренировок</label>
            </div>
            <div class="field__input">
              <div class="grid">
                <div class="grid__col grid__col_sm-12">
                  <div v-for="item in disciplines.slice(0, Math.ceil(disciplines.length / 2))" :key="item.code">
                    <label class="radio">
                      <span class="radio__content">
                        <input
                          v-model="fields.discipline"
                          :value="item.code"
                          class="radio__input"
                          type="radio"
                          name="disciplines"
                        >
                        <span class="radio__marker"></span>
                        <span class="radio__text">{{ item.name }}</span>
                      </span>
                    </label>
                  </div>
                </div>
                <div class="grid__col grid__col_sm-12">
                  <div v-for="item in disciplines.slice(Math.ceil(disciplines.length / 2))" :key="item.code">
                    <label class="radio">
                      <span class="radio__content">
                        <input
                          v-model="fields.discipline"
                          :value="item.code"
                          class="radio__input"
                          type="radio"
                          name="disciplines"
                        >
                        <span class="radio__marker"></span>
                        <span class="radio__text">{{ item.name }}</span>
                      </span>
                    </label>
                  </div>
                </div>
              </div>
              <div class="field__msg">
                <div
                  class="field-msg"
                  v-if="!$v.fields.discipline.required"
                  v-html="messages.discipline.required"
                >
                </div>
              </div>
            </div>
          </div>
        </div>
        <div
          class="form__item"
          :class="{'has-error': $v.fields.description.$error }"
        >
          <div class="field">
            <div class="field__label">
              <label class="label text-md">О&nbsp;чемпионате</label>
            </div>
            <div class="field__subtitle text-sm">
              Опишите идею чемпионата, и&nbsp;какие награды ждут победителей.
            </div>
            <div class="field__input">
              <text-editor
                v-if="ready"
                :content="fields.description"
                @update="$val => { fields.description = $val; $v.fields.description.$touch() }"
              >
              </text-editor>
            </div>
            <div class="field__msg">
              <div
                class="field-msg"
                v-if="!$v.fields.description.required"
                v-html="messages.description.required"
              >
              </div>
            </div>
          </div>
        </div>
        <div class="form__item">
          <div class="divider"></div>
        </div>
        <div class="form__item">
          <button
            v-show="!created"
            class="button button_primary button_wide button_lg"
            :class="{'disabled': showErrors && $v.$anyError, 'button_loading': isSending}"
            :disabled="(showErrors && $v.$anyError) || isSending"
            type="submit"
          >
            <span class="button__text">Создать чемпионат</span>
            <span class="button__icon button__loading">
              <icon icon-name='loading'></icon>
            </span>
          </button>
          <div
            v-show="created"
            class="grid grid_v-center grid_v-margins"
          >
            <div class="grid__col grid__col_auto mr-auto">
              <button
                class="action color-danger"
                type="button"
                @click.prevent="deleteChamp"
              >
                <span class="action__container">
                   <span class="action__icon">
                     <icon icon-name='delete'></icon>
                   </span>
                  <span class="action__text">Удалить черновик</span>
                </span>
              </button>
            </div>
            <div class="grid__col grid__col_auto">
              <button
                class="button button_primary button_lg"
                :class="{'disabled': showErrors && $v.$anyError || deleting, 'button_loading': isSending}"
                :disabled="(showErrors && $v.$anyError) || isSending || deleting"
                type="submit"
              >
                <span class="button__text">Продолжить</span>
                <span class="button__icon button__loading">
                  <icon icon-name='loading'></icon>
                </span>
                <span class="button__icon">
                  <icon icon-name='right'></icon>
                </span>
              </button>
            </div>
          </div>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
import { required } from 'vuelidate/lib/validators'
import TextEditor from '@/components/TextEditor'
import UserCard from '@/components/UserCard'
import DateRangePicker from '@/components/DateRangePicker'
import MobileModal from '@/components/MobileModal'
import cyrillicToTranslit from 'cyrillic-to-translit-js'
import champsService from '@/services/champsService'
import { mapActions } from 'vuex'
import { isEqual, find, clone } from 'lodash'

export default {
  name: 'ChampInfo',
  components: {
    TextEditor,
    UserCard,
    DateRangePicker,
    MobileModal
  },
  props: {
    club: Object,
    champ: Object
  },
  data () {
    return {
      id: null,
      clubCode: null,
      champCode: null,
      fields: {
        name: null,
        date: [null, null],
        discipline: null,
        description: null
      },
      disciplines: [
        {
          code: 'run',
          name: 'Бег'
        },
        {
          code: 'walk',
          name: 'Ходьба'
        },
        {
          code: 'ski-race',
          name: 'Лыжи'
        },
        {
          code: 'cycling',
          name: 'Велозаезд'
        },
        {
          code: 'swimming',
          name: 'Плавание'
        }
      ],
      messages: {
        name: {
          required: 'Введите название чемпионата'
        },
        date: {
          required: 'Укажите период проведения',
          overlaps: 'Изменение периода чемпионата приведет к неверному состоянию тренировочных этапов'
        },
        discipline: {
          required: 'Выберите вид спорта'
        },
        description: {
          required: 'Опишите ваш чемпионат в&nbsp;подробностях'
        }
      },
      backendErrors: {
        dateOverlaps: false
      },
      showErrors: false,
      isSending: false,
      created: false,
      savedData: null,
      deleting: false,
      ready: false
    }
  },
  validations: {
    fields: {
      name: {
        required
      },
      date: {
        isFilled (val) {
          if (!val) {
            return false
          }
          return !!(val[0] && val[1])
        }
      },
      discipline: {
        required
      },
      description: {
        required,
        isFilled (val) {
          if (!val) {
            return false
          }
          return val.replace(/\s/g, '') !== '<p></p>'
        }
      }
    }
  },
  computed: {
    formattedDate () {
      if (!this.ready) {
        return null
      }
      return this.fields.date[0] ? this.$refs.mobileDatepicker.formatValue(this.fields.date) : null
    },
    clubLink () {
      const route = this.$router.resolve({
        name: 'Club',
        params: {
          id: this.clubCode
        }
      })
      return route.href
    },
    manageClubLink () {
      const route = this.$router.resolve({
        name: 'ManageSettings',
        params: {
          id: this.clubCode
        }
      })
      return route.href
    },
    manageChampsLink () {
      const route = this.$router.resolve({
        name: 'ManageChamps',
        params: {
          id: this.clubCode
        }
      })
      return route.href
    }
  },
  methods: {
    ...mapActions('alerts', ['addSomethingWrongAlert']),
    submit () {
      this.showErrors = true
      this.$v.$touch()

      if (this.$v.$anyError) {
        this.scrollToError()
        return
      }

      for (const i in this.backendErrors) {
        if (Object.prototype.hasOwnProperty.call(this.backendErrors, i)) {
          this.backendErrors[i] = false
        }
      }

      if (!this.created) {
        this.createChamp()
      } else {
        this.editChamp()
      }
    },
    scrollToError () {
      setTimeout(() => {
        const firstErrorEl = document.querySelector('.has-error')
        const offset = firstErrorEl.getBoundingClientRect().top + document.documentElement.scrollTop - 112
        window.scrollTo(0, offset)
      }, 10)
    },
    prepareData () {
      const start = this.fields.date[0]
      const finish = this.fields.date[1]
      return {
        clubId: this.club.id,
        clubCode: this.clubCode,
        clubName: this.club.name,
        name: this.fields.name,
        description: this.fields.description,
        startDate: this.$moment(start).format('YYYY-MM-DDTHH:mm:ss'),
        finishDate: this.$moment(finish).format('YYYY-MM-DDTHH:mm:ss'),
        discipline: this.fields.discipline
      }
    },
    createChamp () {
      const data = this.prepareData()

      if (!this.champCode) {
        const code = cyrillicToTranslit().transform(this.fields.name, '_').toLowerCase()
        this.champCode = data.code = this.clubCode + '_' + code
      } else {
        data.code = this.champCode
      }

      this.isSending = true

      champsService.createChamp(data)
        .then((res) => {
          const d = res.data
          if (d.Success) {
            data.champId = d.ChampionshipId
            this.savedData = clone(data)
            this.onSuccess(d.ChampionshipId, data, true)
          } else {
            this.checkError(d.Error)
          }
        })
        .catch(() => {
          this.addSomethingWrongAlert()
          this.isSending = false
        })
    },
    editChamp () {
      const data = this.prepareData()
      data.champId = this.id
      data.code = this.champCode

      if (this.savedData && isEqual(data, this.savedData)) {
        this.onSuccess(this.id, data, false)
        return
      }

      this.isSending = true

      champsService.editChampInfo(data)
        .then((res) => {
          const d = res.data
          if (d.Success) {
            this.savedData = clone(data)
            this.onSuccess(d.ChampionshipId, data, true)
          } else {
            this.checkError(d.Error)
          }
          this.isSending = false
        })
        .catch(() => {
          this.addSomethingWrongAlert()
          this.isSending = false
        })
    },
    deleteChamp () {
      if (this.deleting) {
        return
      }

      this.$root.confirmDialog(
        {
          title: 'Вы уверены, что хотите удалить черновик?',
          confirmText: 'Удалить'
        },
        () => {
          this.deleting = true

          champsService.deleteChamp({
            champId: this.id
          })
            .then((res) => {
              const data = res.data

              if (data.Success) {
                this.$router.replace({
                  params: { champ: null }
                })
                window.open(window.location.origin + this.manageChampsLink, '_self')
              } else {
                this.deleting = false
                this.addSomethingWrongAlert()
              }
            })
            .catch(() => {
              this.deleting = false
              this.addSomethingWrongAlert()
            })
        }
      )
    },
    checkError (errCode) {
      if (errCode === 4) {
        let t = this.$moment().unix() + ''
        t = '_' + t.slice(-3)
        this.champCode += t
        this.createChamp()
      } else if (errCode === 21) {
        this.backendErrors.dateOverlaps = true
        this.scrollToError()
        this.isSending = false
      } else {
        this.addSomethingWrongAlert()
        this.isSending = false
      }
    },
    onSuccess (id, data, changed) {
      if (!this.$route.params.champ) {
        this.$router.replace({
          params: {
            champ: id
          }
        })
      }
      this.created = true
      this.id = id

      if (changed) {
        const d = data
        d.champId = id
        d.code = this.champCode

        const discipline = find(this.disciplines, (o) => o.code === this.fields.discipline)
        d.disciplineName = discipline ? discipline.name : null

        this.$emit('changed', d)
      }

      this.$emit('next')
      this.isSending = false
    },
    setChamp (data) {
      const start = data.StartDate
      const finish = data.FinishDate

      this.fields.name = data.Name
      this.fields.date = [
        new Date(start),
        new Date(finish)
      ]
      this.fields.discipline = data.DisciplineCode
      this.fields.description = data.Description
      this.champCode = data.Code

      this.savedData = {
        clubId: this.club.id,
        clubCode: this.clubCode,
        clubName: this.club.name,
        name: this.fields.name,
        description: this.fields.description,
        startDate: start,
        finishDate: finish,
        discipline: this.fields.discipline,
        champId: this.id,
        code: this.champCode
      }

      setTimeout(() => {
        this.ready = true
      })
    }
  },
  created () {
    this.clubCode = this.$route.params.id || this.$getTenantIdClub()
    this.id = this.$route.params.champ
  },
  mounted () {
    if (!this.id) {
      this.ready = true
    } else {
      this.created = true
      champsService.getChampInfo({ champId: this.id })
        .then((res) => {
          const d = res.data
          if (d) {
            this.setChamp(d)
          }
        })
    }
  }
}
</script>

<style lang="scss" scoped>
  .club-avatar {
    width: 64px;
    height: 64px;
  }
</style>
